import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { VisuallyHidden } from 'components/ui/VisuallyHidden/VisuallyHidden';
import {
  ONE_SECOND_IN_MILISECONDS,
  THREE_SECONDS_IN_MILISECONDS,
} from 'constants/timers';
import { useCountdown } from 'hooks/useCountdown/useCountdown';
import { Success as SuccessIcon } from 'icons';
import type { RootState } from 'reducers/types';
import { getRecipientName } from 'selectors';
import { useTranslations } from 'utils';

import { RedirectToReturnCTA } from '../RedirectToReturnCTA/RedirectToReturnCTA';

import './RedirectCountdown.scss';

type Props = ConnectedProps<typeof connector>;

function RedirectCountdownComponent({ recipientName }: Props) {
  const { timeLeft, isDone } = useCountdown(THREE_SECONDS_IN_MILISECONDS);

  const i18n = useTranslations();

  return (
    <>
      <div className="RedirectCountdown">
        <SuccessIcon className="RedirectCountdown-icon" />
        <h2 className="RedirectCountdown-title">
          {i18n.t('redirectCountdown.payment.completed')}
        </h2>
        <div className="RedirectCountdown-message">
          {i18n.t('redirectCountdown.redirectingMessage', {
            recipient: recipientName as string,
          })}
        </div>
        <span aria-hidden className="RedirectCountdown-status">{`${i18n.t(
          'redirectCountdown.countdown',
        )} ${timeLeft / ONE_SECOND_IN_MILISECONDS}...`}</span>
        <VisuallyHidden as="span" role="alert">
          {i18n.t('redirectCountdown.hiddenRedirectingMessage')}
        </VisuallyHidden>
      </div>
      {isDone && <RedirectToReturnCTA />}
    </>
  );
}

const mapStateToProps = (state: RootState) => ({
  recipientName: getRecipientName(state),
});

const connector = connect(mapStateToProps);
const RedirectCountdown = connector(RedirectCountdownComponent);

export { RedirectCountdown };
